// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"4a448f3d","598":"df52eee0","703":"5cfad3d2","787":"1641f87d"}[chunkId] + ".chunk.js";
};